import IGroupersDTO from "src/Interfaces/groupersDTO";
import IBaseDTO from "src/Interfaces/baseDTO";

export interface IRisks extends IBaseDTO{ 
    fullTitle: string,
    permissao: number,
    rib001Codigo: number,
    rib001Id: number,
    rib001Efa001Id: number,
    rib001Ria001Id: number,
    rib001Titulo: string,
    rib001Descricao: string,
    rib001Prevencao: string,
    rib001Descimpacto: string,
    rib001Quadrante: number,
    rib001Local: string,
    rib001Probabilidade: number,
    rib001Impacto: number,
    rib001Grau: number,
    rib001Efa005Id: number,
    rib001Efa002Id: number,
    rib001Situacao: number,
    rib001Data: Date,
    rib001Causa: string,
    rib001Taa005Id: number,
    rib001Taa001Id?: number,
    rib001Taa001Id2?: number,
    rib001EficaciaControle: number,
    eftba005: IResponsable
    ritba001: IRisksClassification,
    ritbb003 : Array<IAnalysis>,
    ritbb004 : Array<Incidents>,
    ritbb007: Array<IPermissions>,
    processo: string,
    ritbb004Lenght: number
    rib001Tags: string | string[] | null;
    userPermission: number;
}

export interface IPermissions{
    rib007Id : number;
    rib007Rib001Id : number;
    rib007Efa004Id : number;
    rib007Efa004Descricao: string;
    rib007Efa005Id : number;
    rib007Efa005Nome: string;
    rib007Permissao : number;
}

export interface Incidents{
    rib004Id: number,
    rib004Rib001Id: number,
    rib004Data: Date,
    rib004Motivo: string,
}

export interface IAnalysis extends IBaseDTO{
    rib003Id: number,
    rib003Rib001Id: number,
    rib003Efa005Id: number,
    rib003Data: Date,
    rib003Descricao: string,
    rib003Probabilidade: number,
    rib003Impacto: number,
    rib003Grau: number,
    rib003Ria002Id: number,
    rib003Ria002Titulo?: string,
    eftba005: IResponsable,
}

export interface IProcess {
    taa005Id: number,
    taa005Descricao: string,
    taa005Ativo: boolean,
}

export interface IResponsable{
    efa005Id: number,
    efa005Nome: string,
    efa005Imagem: string
}

export interface IRisksClassification {
    ria001Id: number,
    ria001Efa001Id: number,
    ria001Descricao: string,
    ria001Ativo: "S" | "N",
    ria001Peso: number,
    ria001Efa002Id: number,
    createdBy: string,
    dateCreated: Date,
    modifiedBy: string,
    dateModified: Date
}


export interface IComponentRisksPanelModal{
    onCallbackDelete?: Function; 
    onCallbackUpdate?: Function; 
}

export interface IComponentRisksPanelModalHistoric{
    selectedRisk: IRisks;
}

export interface IRefModalHistoric{
    actionButtonHistoric: (row: IRisks) => void;
}
  

export interface IRefIRisksModals{
    actionButtonAdd: (onCallback?: Function) => void;
    actionButtonChange: (row: IRisks, isFinaly: boolean) => void;
    actionButtonDelete: (row: IRisks) => void;
}
export interface IRefModalAnalysis{
    actionButtonAdd: (row: IRisks, onCallback?: Function) => void;
    actionButtonChange: (row: IRisks, analysisId: number, onCallback?: Function) => void;
}

export interface IRefmodalRegisterIncident{
    actionButtonRegisterIncident: (row: IRisks, onCallback?: Function) => void;
}

export interface IListOfRisks{
    layoutList?: "card" | "list";
    layoutListRisks?: "table" | undefined;
    data: IRisks[];
    filterListSituation?: RisksSituation;
    filterListQuadrant?: CheckQuadrant;
    onCallbackDelete?: Function;
    onCallbackUpdate?: Function;
}

export interface IGrouperOfRisks{
    grouper: IGroupersRisks;
    filters: IFilters;
    groupersSelect: IGroupersSelect;
    layoutList: "list" | "card";
}

export enum CheckQuadrant{
    THREAT = 1,
    OPPORTUNITY = 2
}

export enum CheckProbability{
    VERY_LOW = 10,
    LOW = 30,
    MODERATE = 50,
    HIGH = 70,
    VERY_HIGH = 90
}

export enum CheckImpact{
    VERY_LOW = 5,
    LOW = 10,
    MODERATE = 20,
    HIGH = 40,
    VERY_HIGH = 80
}

export enum ImpactDescription{
    VERY_LOW = 5,
    LOW = 10,
    MODERATE = 20,
    HIGH = 40,
    VERY_HIGH = 80
}

export enum CheckPermissions{
    NO_PERMISSION = 0,
    VIEW = 1,
    VIEW_AND_EDIT = 2
}


export enum RisksSituation{
    OPEN = 1,
    FINALY = 2,
    CANCELED = 3,
    ALL = 4
}

export interface IFilters{
    filter: string;
    active: string;
    dateStart: string | null;
    dateEnd: string | null;
    quadrant?: string;
    rangeStart?: number;
    rangeEnd?: number;
    ria001Id?: number;
    situation?: string;
    classification?: string;
    probability: string;
    impact: string;
    process?: number;
    projects?: number;
    responsable?: number | string;
    tags: string | undefined;
    risk: string;
    riskSector: string;
    impactSector: string;
}  


export enum GroupersRisks{
    RISK_CLASSIFICATION = "1",
    RESPONSIBLE = "2",
    PROCESSES = "3",
    PROJECTS = "4",
    RISK_SECTOR = "5",
    IMPACT_SECTOR = "6"
}

export interface IGroupersSelect{
    group: GroupersRisks;
}

export interface IGroupersRisks extends IGroupersDTO<IGroupersRisks>{
    finished: number;
    opened: number;
    canceled: number;
    opportunity: number;
    threat: number;
}


export enum ModalType{
    MODAL_HISTORIC = 1,
    MODAL_ANALYSIS = 2,
    MODAL_ADD_CHANGE = 3
}

export enum RiskSituationFilter{
    OPENED = "Aberto",
    FINISHED = "Concluída",
    CANCELED = "Cancelada",
}
